/* Effets facon Magic UI, sans React : titres mot par mot, chiffres qui
   montent, lumiere qui suit la souris. Plusieurs sections chargent ce
   fichier : le garde-fou evite de tout installer deux fois. Le CSS est dans
   skydrift.css, rubrique « effets ». */
(function () {
  if (window.__skydriftEffets) return;
  window.__skydriftEffets = true;
  // une fiche produit doit se lire d'un coup : ni mots qui montent, ni chiffres qui comptent
  const calme = window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
    !!document.querySelector('main[data-template^="product"]');

  // titres : un <span class="mot"> par mot ; le CSS les fait monter quand
  // skydrift-reveal.js pose .vu sur le bloc. Un titre avec du balisage
  // (un <em> par exemple) est laisse tel quel.
  if (!calme) {
    document.querySelectorAll(".section-heading-bloc .section-heading").forEach(h => {
      if (h.children.length) return;
      h.innerHTML = h.textContent.trim().split(/\s+/)
        .map((m, i) => `<span class="mot" style="--i:${i}">${m.replace(/&/g, "&amp;").replace(/</g, "&lt;")}</span>`)
        .join(" ");
    });
  }

  // chiffres : le dernier nombre du texte compte depuis zero (« 1:18 », « 23 cm »).
  // Sans JS ou en mouvement reduit, la valeur finale est deja affichee.
  const chiffres = document.querySelectorAll("[data-compte]");
  if (!calme && chiffres.length) {
    const compte = el => {
      const texte = el.textContent;
      const m = [...texte.matchAll(/\d+(?:,\d+)?/g)].pop();
      if (!m) return;
      const decimales = (m[0].split(",")[1] || "").length;
      const cible = parseFloat(m[0].replace(",", "."));
      const avant = texte.slice(0, m.index), apres = texte.slice(m.index + m[0].length);
      const t0 = performance.now(), duree = 1400;
      const pas = t => {
        const p = Math.min((t - t0) / duree, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = avant + (cible * e).toLocaleString("fr-FR",
          { minimumFractionDigits: decimales, maximumFractionDigits: decimales }) + apres;
        if (p < 1) requestAnimationFrame(pas);
      };
      requestAnimationFrame(pas);
    };
    const oeil = new IntersectionObserver(entrees => entrees.forEach(e => {
      if (!e.isIntersecting) return;
      compte(e.target);
      oeil.unobserve(e.target);
    }), { threshold: 0.6 });
    chiffres.forEach(c => oeil.observe(c));
  }

  // lumiere sous la souris : on ne fait que poser la position, le CSS dessine
  if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
    document.querySelectorAll(".spot").forEach(el => {
      el.addEventListener("pointermove", e => {
        const r = el.getBoundingClientRect();
        el.style.setProperty("--x", e.clientX - r.left + "px");
        el.style.setProperty("--y", e.clientY - r.top + "px");
      });
    });
  }
})();
